import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const MODULE_ROUTES = [
  { permKey: 'dashboard', path: '/dashboard' },
  { permKey: 'funds', path: '/funds' },
  { permKey: 'investments', path: '/investments' },
  { permKey: 'drawdowns', path: '/drawdowns' },
  { permKey: 'ai_certification', path: '/ai-certification' },
  { permKey: 'data_rooms', path: '/data-rooms' },
  { permKey: 'investor_contacts', path: '/investors/contacts' },
  { permKey: 'investor_accounts', path: '/investors/accounts' },
  { permKey: 'investor_reports', path: '/investors/reports' },
];

const SmartRedirect = () => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user) return <Navigate to="/login" replace />;

  if (user.user_type === 'owner') return <Navigate to="/owner/dashboard" replace />;

  const ep = user.effective_permissions || user.module_permissions || {};
  const first = MODULE_ROUTES.find(m => ep[m.permKey] === true);

  return <Navigate to={first ? first.path : '/dashboard'} replace />;
};

export default SmartRedirect;
